import React, { useState } from 'react';

import settings from './settings.png';

function MobileMessage() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        setSubmitted(true); 
    };

    return (
        <div className="flex justify-center items-center min-h-screen">
        <div className="w-full max-w-md p-5"> 
        <h1 className="mb-4 text-6xl font-bold">Coming Soon!</h1>
        <p className="pl-1">Our mobile experience is currently underway! Thank you for your patience.</p>
        <img src={settings} alt="Description" className="w-80 mx-auto pt-12"/> 

        {submitted ? (
          <p className="mt-12">Thank you for subscribing! You will be notified once our mobile experience is ready.</p>
        ) : (
          <form onSubmit={handleSubmit} className="mt-12">
            {/* <label htmlFor="email" className="block text-sm font-medium text-gray-700">Notify me:</label> */}
            <div className='flex h-8 rounded focus-within:ring-[#cfcfb4] focus-within:ring-offset focus-within:ring-[3px] '>
              <input
                type="email"
                name="email"
                id="email"
                className='text-sm w-full rounded-l h-8 focus:ring-0 border-black focus:border-black'
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button
                type="submit"
                className='bg-black text-white rounded-r px-5 h-8 appearance-none border-black focus:ring-0 focus:border-black cursor-pointer whitespace-nowrap text-sm'
                >
                Notify me!
              </button>


            </div>
          </form>
        )}
        </div>
    </div>
    );
}

export default MobileMessage;

